import React from "react";
import PropTypes from "prop-types";
import FadeLoader from "react-spinners/FadeLoader";
import "./style.scss";

export default function Loader({
  card = true,
  loader = "fadeloader",
  color = "",
}) {
  return (
    <div className={card ? "loader-card" : ""}>
      {loader == "fadeloader" && (
        <FadeLoader color={color ? color : "var(--lara-light-green-600)"} />
      )}
    </div>
  );
}

Loader.propTypes = {
  loaderType: PropTypes.string,
  card: PropTypes.bool,
  loader: PropTypes.string,
  color: PropTypes.string,
};
